module.exports = __webpack_public_path__ + "img/Frame 106.5acad5fa.png";